<i
  class="checkbox-input"
  [class.checkbox-input--checked]="model"
  [class.checkbox-input--mixed]="mixed"
></i>

<ng-content></ng-content>
